import React from 'react';
import _get from 'lodash/get';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import ResourceItemSelector from 'components/ResourceItemSelector';

const useStyles = makeStyles(theme => ({
  container: {
    height: 290,
  },
  contentWrapper: {
    height: 'unset',
  },
  contentRatingWrapper: {
    height: 'unset',
  },
  title: {
    '-webkit-line-clamp': '1',
    maxHeight: 17,
  },
  subTitle: {
    '-webkit-line-clamp': '1',
    maxHeight: 17,
  },
  button: {
    color: theme.palette.primary.main,
    padding: '10px 16px',
    borderRadius: 8,
    border: `1px solid ${theme.palette.primary.main}`,
    width: '100%',
  },
}));

const RecommendedBooksPreview = ({
  items,
  renderButton,
  coursesSiteCopy,
  areSavedResources,
}) => {
  const classes = useStyles();

  const getButton = ({ resource, isDisabled, isSaved, onClick }) => {
    const resourceId = _get(resource, 'sys.id');
    const buttonTextProperty = areSavedResources
      ? 'remove'
      : isSaved
      ? 'savedToReadingList'
      : 'saveToReadingList';

    return (
      <Button
        className={classes.button}
        variant="outlined"
        color="primary"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          onClick(resourceId, true);
        }}
        disabled={isDisabled}
      >
        {_get(coursesSiteCopy, ['pageCopy', buttonTextProperty])}
      </Button>
    );
  };

  const getRenderFooter = item => () => {
    const saveForLaterButton = renderButton(item, getButton);

    return (
      <Box width="100%" mt={2} mb={2}>
        {saveForLaterButton}
      </Box>
    );
  };

  return (
    <Grid container spacing={2}>
      {items.map(item => (
        <Grid item key={_get(item, 'sys.id')} lg={3} md={4} sm={4} xs={12}>
          <ResourceItemSelector
            item={item}
            openLinkInNewTab
            showFavoriteButton={false}
            renderFooter={getRenderFooter(item)}
            customClasses={{
              container: classes.container,
              contentWrapper: classes.contentWrapper,
              contentRatingWrapper: classes.contentRatingWrapper,
              title: classes.title,
              subTitle: classes.subTitle,
            }}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default RecommendedBooksPreview;
